import { BaseExtension } from '../registry/extension';
export class BasePlugin extends BaseExtension {
}
//# sourceMappingURL=base-plugin.js.map